import { ParameterType } from '@/study-search/enums';
import { AttendanceFilterOptionValue } from '@studyportals/search-filters/server-side';
import { TitleBase } from './TitleBase';

export default class TitleAttendance extends TitleBase {
	private deliveryMethodValue: string;

	protected canHandle(): boolean {
		this.deliveryMethodValue = this.getFilterValue(ParameterType.DELIVERY_METHOD);

		return (
			this.indexableFilters.length === 1 &&
			this.indexableFilters.some((_) => _.type === ParameterType.DELIVERY_METHOD && _.values[0] as AttendanceFilterOptionValue === AttendanceFilterOptionValue.ONLINE)
		);
	}

	protected getPageTitle(): string {
		return `${this.deliveryMethodValue} ${this.titlePortalType.toLowerCase()} from around the world`;
	}

	protected getMetaTitle(): string {
		return `Discover ${this.totalSearchResults} ${this.deliveryMethodValue} ${this.titlePortalType} worldwide`;
	}

	protected getMetaDescription(): string {
		return (
			`Explore all accredited ${this.deliveryMethodValue} ${this.titlePortalType} worldwide. ` +
			`Elevate your career with flexible, top-tier education with ${this.portalName}.`
		);
	}
}
